import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useTheme } from '@mui/styles';

function RowComponent(props) {
  const theme = useTheme();
  return (
    <Table.Row
      {...props}
      sx={{
        '&:hover': {
          backgroundColor: `${theme.palette.action.hover} !important`
        },
        '& > td': {
          whiteSpace: 'unset !important',
          wordBreak: 'break-word'
        }
      }}
    />
  );
}

export default RowComponent;
